import { assign, createMachine } from "xstate";
import { DividendWizardState } from "./types/dividendWizardState";
import {
  defaultContext,
  DividendWizardContext,
} from "./types/dividendWizardContext";
import { DividendWizardEvent } from "./types/dividendWizardEvent";
import {
  loadBooking,
  loadInvestment,
  updateDividend,
  validateSingleBooking,
} from "./services";
import {
  addAxiosErrorToContextAction,
  addValidationErrorAction,
  clearValidationErrorAction,
  setBookingAction,
  setDividendValuesAction,
  setDividendValuesFromBookingAction,
  setInvestmentAction,
  setValidatedParams,
} from "./actions";

export const editDividendWizardSM = createMachine<
  DividendWizardContext,
  DividendWizardEvent,
  DividendWizardState
>(
  {
    id: "editDividendWizardSM",
    initial: "idle",
    context: defaultContext,
    states: {
      idle: {
        on: {
          INIT_FROM_INVESTMENT: { target: "loadInvestment" },
        },
      },
      loadInvestment: {
        id: "loadInvestment",
        invoke: {
          id: "loadInvestment",
          src: loadInvestment,
        },
        on: {
          LOADED_INVESTMENT: {
            target: "loadBooking",
            actions: ["setInvestmentAction"],
          },
          SOMETHING_WRONG: { target: "somethingWrong" },
        },
      },
      loadBooking: {
        id: "loadBooking",
        invoke: {
          id: "loadBooking",
          src: loadBooking,
        },
        on: {
          LOADED_BOOKING: {
            target: "editManualDividend",
            actions: ["setDividendValuesFromBookingAction"],
          },
        },
      },
      editManualDividend: {
        id: "editManualDividend",
        on: {
          DIVIDEND_FILLED: {
            target: "validateDividends",
            actions: ["clearValidationErrorAction", "setDividendValuesAction"],
          },
        },
      },
      validateDividends: {
        id: "validateDividends",
        invoke: {
          id: "validateSingleBooking",
          src: validateSingleBooking,
        },
        on: {
          DIVIDENDS_VALIDATED: [
            {
              target: "persist",
              actions: ["setValidatedParams"],
              cond: (context) => Boolean(context.skipSummaryStep),
            },
            {
              target: "summary",
              actions: ["setValidatedParams"],
            },
          ],
          BACK: {
            target: "editManualDividend",
            actions: ["addValidationErrorAction"],
          },
          SOMETHING_WRONG: { target: "somethingWrong" },
        },
      },
      summary: {
        id: "summary",
        on: {
          PERSIST: {
            target: "persist",
          },
          BACK: {
            target: "editManualDividend",
          },
        },
      },
      persist: {
        id: "persist",
        invoke: {
          id: "updateDividend",
          src: updateDividend,
        },
        on: {
          SUCCESS: {
            target: "success",
          },
          SOMETHING_WRONG: { target: "somethingWrong" },
        },
      },
      success: {
        id: "success",
        type: "final",
      },
      somethingWrong: {
        type: "final",
        id: "somethingWrong",
        entry: ["addAxiosErrorToContextAction"],
      },
    },
  },
  {
    actions: {
      addAxiosErrorToContextAction: assign(addAxiosErrorToContextAction),
      setBookingAction: assign(setBookingAction),
      setInvestmentAction: assign(setInvestmentAction),
      setDividendValuesAction: assign(setDividendValuesAction),
      clearValidationErrorAction: assign(clearValidationErrorAction),
      setValidatedParams: assign(setValidatedParams),
      addValidationErrorAction: assign(addValidationErrorAction),
      setDividendValuesFromBookingAction: assign(
        setDividendValuesFromBookingAction
      ),
    },
  }
);
